module.exports = __webpack_public_path__ + "img/image-father.64b09af4.svg";